import { FC } from 'react'

import { useForm } from '@tanstack/react-form'
import { getRouteApi, useRouteContext } from '@tanstack/react-router'
import { Toast, handleFormSubmissionError } from 'ui/components'
import { useSaveDocumentPeriod } from '~bank-documents/service/periodEdit'
import { ManagePeriodForm, ManagePeriodResponse } from '~bank-documents/types/periodEdit'

import { ManagePeriodDialog } from '../commonPages/ManagePeriodDialog'

const EditPeriod: FC = () => {
  //@ts-ignore what context? can't find isDocumentDetailsPage
  const { isDocumentDetailsPage } = useRouteContext({ strict: false })

  const routeApi = getRouteApi(
    //@ts-ignore make different entry point for these routes?
    isDocumentDetailsPage
      ? '/_app/documents/$documentId/edit-period/$periodId'
      : '/_app/documents/$documentId/periods/$periodId/edit'
  )

  const navigate = routeApi.useNavigate()

  //@ts-ignore make different entry point for routes above?
  const periodId = routeApi.useParams({ select: (s) => s.periodId })
  //@ts-ignore make different entry point for routes above?
  const documentId = routeApi.useParams({ select: (s) => s.documentId })

  const webPageData: ManagePeriodResponse = routeApi.useLoaderData()

  const { form, ...appearanceInfo } = webPageData

  const formApi = useForm({
    defaultValues: new ManagePeriodForm(false, form),
    onSubmit: async ({ value }) => await savePeriod({ id: Number(periodId), ...value })
  })

  const onClose = () => {
    if (isDocumentDetailsPage) {
      navigate({ to: '/documents/$documentId', params: { documentId }, resetScroll: false })
    } else {
      navigate({ to: '/documents/$documentId/periods/$periodId', params: { documentId, periodId }, resetScroll: false })
    }
  }

  const { routine: savePeriod } = useSaveDocumentPeriod({
    onSuccess: async () => {
      Toast.successSmall('Period was successfully updated.')

      onClose()
    },
    onError: (error) => {
      handleFormSubmissionError<ManagePeriodForm>(error, formApi)
    }
  })

  return (
    <ManagePeriodDialog
      id={Number(periodId)}
      form={formApi}
      dialogTitle="Edit Document Period"
      appearanceInfo={appearanceInfo}
      onClose={onClose}
    />
  )
}

export default EditPeriod
